/**
 * Frontend feature flags — soft switches that hide / show whole features in
 * the UI without removing any code or backend endpoints.
 *
 * Each flag can also be overridden at runtime by an env var
 * (REACT_APP_FEATURE_<NAME>=true|false) so we can flip a feature on/off in a
 * single deploy without touching source.
 *
 * To turn a feature back ON:
 *   - flip its value here to `true`,                       OR
 *   - set REACT_APP_FEATURE_<NAME>=true in /app/frontend/.env and restart frontend.
 */

function envBool(name, fallback) {
  const raw = process.env[name];
  if (raw === undefined || raw === null || raw === "") return fallback;
  return String(raw).toLowerCase() === "true" || raw === "1";
}

export const FEATURES = {
  // Hide the Leads / CRM-pipeline feature across the UI (sidebar, dashboard
  // widget, /leads route). Backend /api/leads/* stays fully functional so the
  // flag is reversible with a single edit.
  leads: envBool("REACT_APP_FEATURE_LEADS", false),

  // Hide the Payroll feature (UI only). Backend /api/payroll/* remains live
  // and seeded data untouched. Flip to `true` (or set REACT_APP_FEATURE_PAYROLL=true)
  // to restore the sidebar entry and /payroll route in a single rebuild.
  payroll: envBool("REACT_APP_FEATURE_PAYROLL", false),

  // Hide the Resources (lesson materials library) feature in the UI. Backend
  // /api/resources/* + seeded folders/files are untouched. Flip to `true`
  // (or REACT_APP_FEATURE_RESOURCES=true) to restore in a single rebuild.
  resources: envBool("REACT_APP_FEATURE_RESOURCES", false),

  // Hide the Defaulters (overdue-invoices follow-up) feature in the UI.
  // Backend /api/defaulters/* stays live (the Dashboard's overdue count is
  // intentionally hidden along with the page since the only landing target
  // for the card was /defaulters). Flip to `true` (or REACT_APP_FEATURE_DEFAULTERS=true)
  // to restore in a single rebuild.
  defaulters: envBool("REACT_APP_FEATURE_DEFAULTERS", false),
};

export default FEATURES;
